import { Modal } from "@/components";
import { ResourceName } from "@/utils";
import { Close, ExpandMore, Search } from "@mui/icons-material";
import {
  Button,
  Chip,
  CircularProgress,
  InputAdornment,
  Stack,
  TextField,
} from "@mui/material";
import { useIsFetching } from "@tanstack/react-query";
import { FC, useState } from "react";
import { TopToolbar as RaTopToolbar, useListContext } from "react-admin";
import { UsersFilter } from "../../modals";
import { FiltersList } from "./filters-list.component";
import { useDebouncedListSearch } from "@/hooks";

const TopToolbar: FC = () => {
  const { sort, setSort } = useListContext();

  const isUsersFetching = useIsFetching({
    queryKey: [ResourceName.VETTING_USERS, "getList"],
  });

  const [isFiltersModalOpened, setIsFiltersModalOpened] = useState(false);
  const [searchQuery, setSearchQuery] = useDebouncedListSearch();

  return (
    <>
      {/* Modal used here due to RA listContext */}
      <Modal
        title="Filters"
        isOpened={isFiltersModalOpened}
        onClose={() => setIsFiltersModalOpened(false)}
        children={
          <UsersFilter onModalClose={() => setIsFiltersModalOpened(false)} />
        }
      />

      <RaTopToolbar
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          marginTop: 1,
          paddingRight: 0,
          paddingLeft: 0,
        }}
      >
        <Stack
          direction={"row"}
          sx={{
            width: "100%",
            justifyContent: "space-between",
            alignItems: "flex-end",
          }}
        >
          {sort.field === "completedOnboardingAt" ? (
            <Chip
              size="small"
              variant="filled"
              label={"Sorted by: Date of Application"}
              onDelete={() => setSort({ field: "status", order: "ASC" })}
            />
          ) : (
            <div />
          )}

          <Stack direction={"row"} spacing={1}>
            <TextField
              size="small"
              variant="outlined"
              placeholder="Search by user"
              sx={{ width: "220px" }}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              slotProps={{ htmlInput: { maxLength: 50 } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    {!!isUsersFetching && <CircularProgress size={16} />}
                    {!isUsersFetching && !!searchQuery && (
                      <Close
                        sx={{ cursor: "pointer" }}
                        onClick={() => setSearchQuery("")}
                      />
                    )}
                  </InputAdornment>
                ),
              }}
            />
            <Button
              size="small"
              endIcon={<ExpandMore />}
              sx={{ minWidth: "auto" }}
              onClick={() => setIsFiltersModalOpened(true)}
            >
              Filters
            </Button>
          </Stack>
        </Stack>

        <FiltersList />
      </RaTopToolbar>
    </>
  );
};

export { TopToolbar };
